import { setNotificationSettings } from "pages/Notification/notificationDestinationSlice"; // adjust path as needed
import { useDispatch } from "react-redux";
import CheckboxComp from "themes/elements/Checkbox";
import ChipSelect from "themes/elements/ChipSelect";
import DatePickerComp from "themes/elements/DatePicker";
import RadioComp from "themes/elements/Radio";
import TimePickerComp from "themes/elements/TimePicker";
import { notificationTypeData } from "../../config";
import style from "../../create_noti.module.scss";

function NotificationSettings(props) {
  const {
    notificationType,
    setNotificationType,
    setFormData,
    formData,
    disableStartDate,
    disableEndDate,
    isDuplicate,
    isEdit,
    recipients,
    recipientsData,
    setRecipientsFlag,
    setRecipientsData,
    expire,
    setExpire,
    disableExpiryDate,
    schedule,
    disableScheduleDate,
    setSchedule,
    isReadOnly = false,
    showSchedule = false,
    scheduleLabel = "Schedule for publishing",
  } = props;

  const dispatch = useDispatch();

  return (
    <div className={`flex flex-column gap-5 ${style["left-section"]}`}>
      {/* Notification Type */}
      <div className="flex flex-column gap-2">
        <label className="input-label">Notification type</label>
        <div className="flex align-center gap-4">
          <RadioComp
            data={notificationTypeData}
            displayTooltip={true}
            selected={notificationType}
            disabled={isReadOnly}
            onChange={(value) => {
              dispatch(setNotificationSettings(value)); // Save to Redux
              setNotificationType(value);
              setFormData((prevData) => ({
                ...prevData,
                notificationType: value,
                startDate: null,
                startTime: null,
                endDate: null,
                endTime: null,
              }));
            }}
          />
        </div>
      </div>
      {/* Time Period for Alert */}
      {notificationType?.toLowerCase().replace(" ", "") === "alert" && (
        <div className="flex flex-column gap-2">
          {/* Start date and time */}
          <div className="flex align-center gap-4">
            <DatePickerComp
              defaultValue={formData.startDate}
              onChange={(dateString) => {
                setFormData((prevData) => ({
                  ...prevData,
                  startDate: dateString,
                  startTime: null,
                }));
              }}
              disabledDate={disableStartDate}
              placeholder="Start date"
              disabled={isReadOnly}
            />
            <TimePickerComp
              date={formData?.startDate}
              defaultValue={formData?.startTime}
              onChange={(time, time12HourFormat, time24HourFormat) =>
                setFormData((prevData) => ({
                  ...prevData,
                  startTime: time24HourFormat,
                }))
              }
              placeholder="Start time"
              disabled={isReadOnly || !formData.startDate}
            />
          </div>
          {/* End date and time */}
          <div className="flex align-center gap-4">
            <DatePickerComp
              defaultValue={formData.endDate}
              onChange={(dateString) =>
                setFormData((prevData) => ({
                  ...prevData,
                  endDate: dateString,
                  endTime: null,
                }))
              }
              disabledDate={disableEndDate}
              placeholder="End date"
              disabled={isReadOnly}
            />
            <TimePickerComp
              date={formData.endDate}
              startTime={formData.startTime}
              isEndTime={true}
              defaultValue={formData?.endTime}
              onChange={(time, time12HourFormat, time24HourFormat) =>
                setFormData((prevData) => ({
                  ...prevData,
                  endTime: time24HourFormat,
                }))
              }
              placeholder="End time"
              disabled={isReadOnly || !formData.endDate}
            />
          </div>
        </div>
      )}
      {/* Recipients */}
      <ChipSelect
        isDuplicate={isDuplicate}
        isEdit={isEdit}
        label="Recipients"
        options={recipients}
        defaultValues={recipientsData}
        setRecipientsFlag={setRecipientsFlag}
        value={formData.recipients}
        onChange={(selectedRecipients) => {
          setRecipientsData(selectedRecipients);
        }}
      />
      {/* Set Expiry Date */}
      <div className="flex flex-column gap-2">
        <CheckboxComp
          isChecked={expire}
          setChecked={setExpire}
          label="Set an expiry date"
          disabled={isReadOnly}
        />
        {expire && (
          <div className="flex align-center gap-4">
            <DatePickerComp
              defaultValue={formData.expiryDate}
              onChange={(dateString) =>
                setFormData((prev) => ({
                  ...prev,
                  expiryDate: dateString,
                  expiryTime: null,
                }))
              }
              disabledDate={disableExpiryDate}
              onOk={() => {}}
              disabled={isReadOnly}
            />
            <TimePickerComp
              date={formData.expiryDate}
              defaultValue={formData?.expiryTime}
              onChange={(time, time12HourFormat, time24HourFormat) =>
                setFormData((prev) => ({
                  ...prev,
                  expiryTime: time24HourFormat,
                }))
              }
              placeholder="Expiry time"
              disabled={isReadOnly || !formData.expiryDate}
            />
          </div>
        )}
      </div>
      {/* Schedule Publishing — only shown to approvers */}
      {showSchedule && (
        <div className="flex flex-column gap-2">
          <CheckboxComp
            isChecked={schedule}
            setChecked={setSchedule}
            label={scheduleLabel}
            disabled={isReadOnly}
          />
          {schedule && (
            <div className="flex align-center gap-4">
              <DatePickerComp
                defaultValue={formData.scheduleDate}
                onChange={(dateString) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    scheduleDate: dateString,
                    scheduleTime: null,
                  }))
                }
                disabledDate={disableScheduleDate}
                disabled={isReadOnly}
              />
              <TimePickerComp
                date={formData.scheduleDate}
                defaultValue={formData?.scheduleTime}
                onChange={(time, time12HourFormat, time24HourFormat) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    scheduleTime: time24HourFormat,
                  }))
                }
                disabled={isReadOnly || !formData.scheduleDate}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default NotificationSettings;
